import { z } from 'zod';

const plateNumberSchema = (plateNumber: string) =>
  plateNumber.match('^[0-9]{3,4}$');

export const getPlateNumberValidation = () =>
  z
    .string()
    .min(1, {
      message: '此欄位為必填',
    })
    .refine(plateNumberSchema, {
      message: '需輸入車牌 3-4 位連號數字',
    });
